import { Link } from 'react-router';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import Pagination from '../../components/Pagination';
import NewsCard from '../../components/NewsCard';

import useNewsList from '../../hooks/useNewsList';
import Preloader from '../../components/Preloader';

function News() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language; // "bs" or "en"

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const { data: newsPosts = [], isLoading, isError } = useNewsList();

  const hasNews = newsPosts.length > 0;

  // Pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedPosts = newsPosts.slice(startIndex, endIndex);

  return (
    <div>
      {isLoading && <Preloader />}

      <PageHeader
        title={t('newsPage.title')}
        page={t('newsPage.page')}
        pageUrl={'news'}
      />

      <div id="blog-home" className="page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-xl-9">
              {isLoading ? (
                <div
                  className="mt-4"
                  style={{
                    padding: '50px 0',
                    textAlign: 'center',
                    fontSize: '1.2rem',
                    color: '#555',
                  }}
                >
                  {t('newsPage.loading_news')}
                </div>
              ) : isError ? (
                <div className="alert alert-danger mt-4">
                  Error loading news
                </div>
              ) : !hasNews ? (
                <div className="alert alert-info mt-4">
                  {t('newsPage.noNews')}
                </div>
              ) : (
                paginatedPosts.map(post => (
                  <div
                    key={post._id}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <NewsCard post={post} lang={lang} allNews={newsPosts} />
                  </div>
                ))
              )}

              {/* Pagination */}
              {!isLoading &&
                !isError &&
                hasNews &&
                newsPosts.length > itemsPerPage && (
                  <div className="col-md-12 mt-5">
                    <Pagination
                      page={currentPage}
                      totalItems={newsPosts.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={setCurrentPage}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default News;
